// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectRouteMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_ROUTE);
        // 0 bit == 1 -> active
        // 1 bit == 1 -> !active
        // 2 bit == 1 -> started
        // 3 bit == 1 -> !started
        this.RouteStatus = null;
        this.Name = null;
        this.Exchanges = null;
        this.Holidays = null;
        this.QuoteServerAddress = null;
        this.QuoteServerInfo = null;
        this.TradeStatus = 0;
        this.RouteId = 0;
        this.QuoteRouteId = 0;
        this.AllowTypeModify = false;
        this.AllowAmountModify = false;
        this.AllowTifModify = false;
        this.AllowPriceModify = false;
        this.AllowOperationTypeModify = false;
        this.AllowExpirationDateModify = false;
        this.DictOrderTypeTifs = {};
        this.IsNewsRoute = null;
        this.QuoteDelay = null;
        // #53234 - признак того, как должны обновляться OHLC и Volume/Ticks
        this.InstrumentDayBarMessageUpdateMode = false;
        // В каком виде будет отображаться источник в Time&Sales
        this.ClientShowMode = 0;
    }
    get IsInfo() {
        return (this.TradeStatus & 0x01) === 1;
    }
    get IsTradable() {
        return (this.TradeStatus & 0x02) === 2;
    }
}
